import Box from "@mui/material/Box";
import { InputField, LabelField, SelectField } from "components";
import MyButton from "components/MyButton";
import { TextareaField } from "components/TextareaField";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
const TributeInformation = ({ handleClose }) => {
  const [split, setSplit] = useState(false);
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {},
    validationSchema: "",
    onSubmit: async (values) => {},
  });
  return (
    <div className="new-charge">
      <div className="new-charge-header py-5"> Edit Tribute information</div>
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="">
          <div className="form-content">
            <Box my="2rem" className="mb-0 mx-40 px-10 pr-20">
              <div className=" col-sm-12">
                <Row className="form-row">
                  <Col className="col-sm-6">
                    <SelectField
                      {...{
                        formik,
                        title: "Tribute Type",
                        name: "ledger_account",
                        items: [""],
                        placeholder: "Select",
                      }}
                      onClick={() => {}}
                    />
                  </Col>
                </Row>
                <Row className="form-row">
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Recipient Salutation",
                        name: "donor_salutation",
                        placeholder: "",
                      }}
                    />
                  </Col>
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Recipient Name",
                        name: "donor_name",
                        placeholder: "",
                      }}
                    />
                  </Col>
                </Row>
                <Row className="form-row sm-12 mb-4">
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Recipient Email",
                        name: "email",
                        placeholder: "",
                      }}
                    />
                  </Col>
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Recipient Address",
                        name: "address",
                        placeholder: "",
                      }}
                    />
                  </Col>
                </Row>
                <p className="">
                  <br />
                </p>
                <Row className="form-row sm-12 mb-4">
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Donor Salutation",
                        name: "donor_salutation",
                        placeholder: "",
                      }}
                    />
                  </Col>
                  <Col className="col-sm-6">
                    <InputField
                      {...{
                        formik,
                        title: "Donor Name",
                        name: "donor_name",
                        placeholder: "",
                      }}
                    />
                  </Col>
                </Row>
                <Col className="col-sm-12 px-0 pb-5">
                  <TextareaField
                    {...{
                      formik,
                      rows: 4,
                      title: "Tribute Message",
                      name: "note",
                      placeholder: "Tribute text",
                      style: { resize: "none" },
                    }}
                  />
                </Col>
              </div>
            </Box>
            <div className="">
              <hr />
              <div className="d-flex justify-content-end pb-10 pt-6 pr-22">
                <MyButton
                  type="secondary"
                  content={"Cancel"}
                  onClick={handleClose}
                />
                <span className="mx-3">
                  <MyButton content={"save"} onClick={() => {}} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default TributeInformation;
